{
  "CHAT_LIST": {
    "LOADING": "Obteniendo conversaciones",
    "LOAD_MORE_CONVERSATIONS": "Cargar más conversaciones",
    "EOF": "Todas las conversaciones cargadas 🎉",
    "LIST": {
      "404": "No hay conversaciones activas en este grupo."
    },
    "FAILED_TO_SEND": "Error al enviar",
    "TAB_HEADING": "Conversaciones",
    "MENTION_HEADING": "Menciones",
    "UNATTENDED_HEADING": "Desatendido",
    "SEARCH": {
      "INPUT": "Búsqueda de Personas, Chats, Respuestas Salvadas .."
    },
    "FILTER_ALL": "Todos",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mías",
      "unassigned": "Sin asignar",
      "all": "Todos"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Abiertas"
      },
      "resolved": {
        "TEXT": "Resueltas"
      },
      "pending": {
        "TEXT": "Pendientes"
      },
      "snoozed": {
        "TEXT": "Postpuestas"
      },
      "all": {
        "TEXT": "Todos"
      }
    },
    "VIEW_FILTER": "Ver",
    "SORT_TOOLTIP_LABEL": "Ordenar conversaciones",
    "CHAT_SORT": {
      "STATUS": "Estado",
      "ORDER_BY": "Ordenar por"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Creado",
        "OLDEST": "Creado el:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Última actividad:",
        "ACTIVE": "Última actividad"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Última actividad: Más antigua primero"
      },
      "last_activity_at_desc": {
        "TEXT": "Última actividad: Más reciente primero"
      },
      "created_at_desc": {
        "TEXT": "Creado el: Más Nuevo primero"
      },
      "created_at_asc": {
        "TEXT": "Creado el: Más antiguo primero"
      },
      "priority_desc": {
        "TEXT": "Prioridad: el más alto primero"
      },
      "priority_asc": {
        "TEXT": "Prioridad: el más bajo primero"
      },
      "waiting_since_asc": {
        "TEXT": "Respuesta pendiente: la más larga primero"
      },
      "waiting_since_desc": {
        "TEXT": "Respuesta pendiente: la más corta primero"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      },
      "unread": {
        "TEXT": "Conteo de no leídos: el más alto primero"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Mensaje de imagen"
      },
      "audio": {
        "CONTENT": "Mensaje de audio"
      },
      "video": {
        "CONTENT": "Mensaje de vídeo"
      },
      "file": {
        "CONTENT": "Archivo adjunto"
      },
      "location": {
        "CONTENT": "Ubicación"
      },
      "ig_reel": {
        "CONTENT": "Reel de Instagram"
      },
      "fallback": {
        "CONTENT": "ha compartido una url"
      },
      "contact": {
        "CONTENT": "Contacto compartido"
      },
      "embed": {
        "CONTENT": "Contenido incrustado"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Ordenar conversación",
      "DROPDOWN_TITLE": "Ordenar por",
      "ITEMS": {
        "LATEST": {
          "NAME": "Última actividad el",
          "LABEL": "Última actividad"
        },
        "CREATED_AT": {
          "NAME": "Creado el",
          "LABEL": "Creado el"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Último mensaje de usuario el",
          "LABEL": "Último mensaje"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Recibido por correo electrónico",
    "VIEW_TWEET_IN_TWITTER": "Ver trino en Twitter",
    "REPLY_TO_TWEET": "Responder a éste trino",
    "LINK_TO_STORY": "Ir a la historia de Instagram",
    "SENT": "Enviado con éxito",
    "READ": "Leido correctamente",
    "DELIVERED": "Entregado con éxito",
    "NO_MESSAGES": "No hay mensajes",
    "NO_CONTENT": "No hay contenido disponible",
    "HIDE_QUOTED_TEXT": "Ocultar texto citado",
    "SHOW_QUOTED_TEXT": "Mostrar texto citado",
    "MESSAGE_READ": "Leído",
    "SENDING": "Enviando",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
